import { usePostApiService } from '../use-api-service'
import { CONTACT_PATH } from '../constants'
import type { ContactPayload, ContactResponse } from '../types'

export const useContactService = () => {
  const createContactRequest = usePostApiService<ContactPayload, ContactResponse>(CONTACT_PATH, '', false)

  return { createContactRequest }
}
